import type { CalloutBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface CalloutBlockEditorProps {
  content: CalloutBlockContent | null
  onChange: (content: CalloutBlockContent) => void
}

export function CalloutBlockEditor({ content, onChange }: CalloutBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<CalloutBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Callout</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Type</Label>
          <Select
            value={c.type ?? "info"}
            onValueChange={(v) =>
              update({ type: v as "info" | "tip" | "warning" | "success" })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="info">Info</SelectItem>
              <SelectItem value="tip">Tip</SelectItem>
              <SelectItem value="warning">Warning</SelectItem>
              <SelectItem value="success">Success</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? ""}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Callout heading"
          />
        </div>
        <div>
          <Label>Body</Label>
          <Textarea
            value={c.body ?? ""}
            onChange={(e) => update({ body: e.target.value })}
            placeholder="Callout content"
            rows={3}
            className="resize-none"
          />
        </div>
      </CardContent>
    </Card>
  )
}
